<template>
  <div id="VideoPlayer"  class="contentBox">
    <SectionTitleBar v-on:buttonPress="closeVideoPlayer()" :sectionTitle="video.name" :buttonText="'Close'" />
    <div v-if="indicators" class="indicatorGroup">
      <div v-for="(indicator, name) in indicators" :key="name" class="indicator">
        <div class="indicatorValue">{{indicator}}</div>
        <div class="indicatorLabel">{{name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitleBar from '../components/SectionTitleBar.vue'

export default {
  name: 'videoPlayer',
  props: {
    video: Object
  },
  components: {
    SectionTitleBar
  },
  methods: {
    closeVideoPlayer: function(){
      this.$store.commit('setCurrentVideo',null);
    }
  },
  computed: {
    currentVideo () {
      return this.$store.state.currentVideo
    },
    indicators() {
      if (this.video.performance) {
        var indicators = {}
        var perf = this.video.performance.lifetime
        //indicatorList = ["cpi","cpm","cpr","ctr","ipm","spend"]
        perf.cpi ? indicators["CPI"] = `$${perf.cpi.toFixed(2)}` : null
        perf.cpm ? indicators["CPM"] = `$${perf.cpm.toFixed(2)}` : null
        perf.cpr ? indicators["CPR"] = `$${perf.cpr.toFixed(2)}` : null
        perf.ctr ? indicators["CTR"] = `${(perf.ctr*100).toFixed(2)}%` : null
        perf.ipm ? indicators["IPM"] = `${perf.ipm.toFixed(2)}` : null
        if (perf.spend) {
          if (perf.spend > 999) {
            indicators["Spend"] = `$${perf.spend.toFixed(0)}`
          } else {
            indicators["Spend"] = `$${perf.spend.toFixed(2)}`
          }

        }
        return indicators
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .indicatorGroup {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .indicator {
      width: 120px;
      height: 120px;
      background-color: #2E303A;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      margin: 7px;
      .indicatorValue {
        width: 100%;
        font-size: 25px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
      }
      .indicatorLabel {
        width: 100%;
        font-size: 15px;
        display: flex;
        justify-content: center;
        opacity: .3;
      }
    }
  }
  #VideoPlayer {
    background-color: #333746;
    height: 100%;
    width: 400px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-left: 15px;
  }
  .videoWrapper {
    width: 350px;
    margin-top: 25px;
  }
  .videoWrapper video {
    width: 100%;
  }
  .videoPlayerTitle {
    width: 100%;
  }
</style>
